/** Пустое значение — фильтр не применять: ключ в тело не кладём, иначе выборка схлопнется */

import { MmResultListFilters } from '../../types/dto';
import { MmReviewStatus } from '../../types/enums';

export interface MmResultsScreenFilters {
  /** Пустой список означает всю пачку целиком */
  taskIds: string[];
  competitorCodes: string[];
  auditorLogins: string[];
  types: string[];
  reviewStatuses: string[];
  outcomes: string[];
  /** Даты в формате YYYY-MM-DD, границу суток достраивает бэкенд */
  capturedFrom: string | null;
  capturedTo: string | null;
  search: string;
}

export interface MmResultsRequestFilters extends Partial<MmResultListFilters> {
  competitorCodes?: string[];
  types?: string[];
  capturedFrom?: string | null;
  capturedTo?: string | null;
}

/** Функция, а не константа: общий объект с массивами вызывающие мутировали бы по ссылке */
export function createEmptyResultsFilters(): MmResultsScreenFilters {
  return {
    taskIds: [],
    competitorCodes: [],
    auditorLogins: [],
    types: [],
    reviewStatuses: [MmReviewStatus.PENDING],
    outcomes: [],
    capturedFrom: null,
    capturedTo: null,
    search: '',
  };
}

/** Непустой список строк — копией, чтобы состояние экрана не уехало по ссылке. */
function takeList(source: string[] | null | undefined): string[] | null {
  if (source === null || source === undefined || source.length === 0) {
    return null;
  }

  const result: string[] = [];

  for (let i = 0; i < source.length; i += 1) {
    const value = source[i];

    if (value !== null && value !== undefined && String(value) !== '') {
      result.push(String(value));
    }
  }

  return result.length > 0 ? result : null;
}

function takeText(source: string | null | undefined): string | null {
  if (source === null || source === undefined) {
    return null;
  }

  const text = String(source).trim();

  return text !== '' ? text : null;
}

/** Ключ onlyLatest здесь не выставляется: им владеет таблица, иначе переключатель перезапишется */
export function buildResultsRequestFilters(
  filters: MmResultsScreenFilters,
): Partial<MmResultListFilters> {
  const request: MmResultsRequestFilters = {};

  if (filters === null || filters === undefined) {
    return request;
  }

  const taskIds = takeList(filters.taskIds);
  const competitorCodes = takeList(filters.competitorCodes);
  const auditorLogins = takeList(filters.auditorLogins);
  const types = takeList(filters.types);
  const reviewStatuses = takeList(filters.reviewStatuses);
  const outcomes = takeList(filters.outcomes);
  const capturedFrom = takeText(filters.capturedFrom);
  const capturedTo = takeText(filters.capturedTo);
  const search = takeText(filters.search);

  if (taskIds !== null) {
    request.taskIds = taskIds;
  }

  if (competitorCodes !== null) {
    request.competitorCodes = competitorCodes;
  }

  if (auditorLogins !== null) {
    request.auditorLogins = auditorLogins;
  }

  if (types !== null) {
    request.types = types;
  }

  if (reviewStatuses !== null) {
    request.reviewStatuses = reviewStatuses;
  }

  if (outcomes !== null) {
    request.outcomes = outcomes;
  }

  if (capturedFrom !== null) {
    request.capturedFrom = capturedFrom;
  }

  if (capturedTo !== null) {
    request.capturedTo = capturedTo;
  }

  if (search !== null) {
    request.q = search;
  }

  return request;
}
